module.exports = __webpack_public_path__ + "static/keyboardshortcut-organization-dont-81a9d149831aaa8e43c68d03d37f37c5.png";